require("../../base/js/app.js");
require("slick-carousel");


$(function () {
    $('.login').on('click', function () {
        $.post('/save-event', { 'event': 'login_popup' });
        $('#loginModal').modal('show');
        if ($(this).data('href')) {
            $('#loginModal').find('input[name="redirect"]').val($(this).data('href'));
        }
    });

    const couponCopyBtns = document.querySelectorAll('.js-coupon__copy');

    if (couponCopyBtns.length > 0) {
        couponCopyBtns.forEach((btn) => {
            btn.addEventListener('click', (e) => {
                e.preventDefault();

                const codeText = btn.closest('.js-coupon').querySelector('.js-coupon__input');

                codeText.select();
                codeText.setSelectionRange(0, 99999);

                navigator.clipboard.writeText(codeText.value);
            });
        })
    }
});


// Get all elements with the class "js-modal"
const modalElements = document.querySelectorAll('.js-modal');

// Get the modal container
const modalContainer = document.getElementById('jsLevelModal');

// Get the title and content elements in the modal
const modalTitle = document.getElementById('modalTitle');
const modalContent = document.getElementById('modalContent');

// Function to open the modal with animation
function openModal(title, content) {
    if (modalTitle && modalContent && modalContainer) {
        modalTitle.textContent = title;
        modalContent.innerHTML = content;

        // Add the "open" class
        modalContainer.classList.add('open');
    }
}

// Function to close the modal with animation
function closeModal() {
    if (modalContainer) {
        // Remove the "open" class
        modalContainer.classList.remove('open');
    }
}

// Add click event listeners to all elements with class "js-modal"
if (modalElements) {
    modalElements.forEach((element) => {
        element.addEventListener('click', () => {
            const title = element.getAttribute('data-title');
            const content = element.getAttribute('data-content');
            openModal(title, content);
        });
    });
}

// Add click event listener to close button
const closeButton = document.querySelector('.c-modal__close');
if (closeButton) {
    closeButton.addEventListener('click', closeModal);
}

// Add click event listener to modal backdrop to close modal
const modalBackdrop = document.querySelector('.c-modal__backdrop');
if (modalBackdrop) {
    modalBackdrop.addEventListener('click', closeModal);
}

// Add event listener for the Escape key to close modal
document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
        closeModal();
    }
});



// WEBPACK FOOTER //
// ./resources/assets/fnv/js/app.js